export const environment = {
  production: false,
  TRANSLATION_DOMAIN: 'https://cat-mfe.dev-lotta.ingka.com',
  AUTH0_DOMAIN: 'https://stagicow.accounts.ingka.com',
  AUTH0_CLIENT_ID: 'mxMopbahIiDasDeYQ5HZQAFauRY03fzK',
  AUTH0_AUDIENCE: 'https://ingka-icow-stag.eu.auth0.com/api/v2/',
};
